'use strict';

// Маска телефона в поле с ng-model: ui-mask="+7 (999) 999-99-99". Повторяет angular-ui-mask 1.8.7
// в объёме шаблонов сайта: вид поля, положение каретки, значение модели и проверка «mask».
// В маске: 9 — цифра, A — латинская буква, * — буква или цифра, ? — следующий знак необязателен,
// \ — следующий знак выводится как есть (так фильтр legacyPhoneMask экранирует 9 в коде страны).
angular.module('superdostavka.commonDirectives').directive('uiMask', [function () {
    var DEFINITIONS = { 9: /\d/, A: /[a-zA-Z]/, '*': /[a-zA-Z0-9]/ };

    return {
        restrict: 'A',
        require: 'ngModel',
        // Как в модуле: связывание идёт после директивы input, поэтому её обработчик ввода срабатывает первым.
        priority: 100,
        link: function (scope, element, attrs, ngModel) {
            var input = element[0];
            var caretMap = [];
            var patterns = [];
            var placeholder = '';
            var minLength = 0;
            var optional = false;
            var escaped = false;

            String(attrs.uiMask).split('').forEach(function (chr) {
                if (escaped) {
                    escaped = false;
                    placeholder += chr;
                } else if (chr === '\\') {
                    escaped = true;
                } else if (DEFINITIONS[chr]) {
                    caretMap.push(placeholder.length);
                    patterns.push(DEFINITIONS[chr]);
                    placeholder += '_';
                    minLength += optional ? 0 : 1;
                    optional = false;
                } else if (chr === '?') {
                    optional = true;
                } else {
                    placeholder += chr;
                }
            });
            // Маска без позиций ввода не действует.
            if (!caretMap.length) {
                return;
            }
            // Каретка может стоять и сразу за последней позицией ввода.
            var end = caretMap[caretMap.length - 1] + 1;
            caretMap.push(end);

            // Постоянные части маски убираются из текста перед разбором. Как в модуле, знак сразу
            // после последней позиции ввода к ним не относится.
            var copy = placeholder.slice(0, end) + '_' + placeholder.slice(end + 1);
            var components = [];
            var offset = 0;
            copy.split(/_+/).forEach(function (part) {
                if (part) {
                    offset = copy.indexOf(part, offset);
                    components.push({ value: part, position: offset });
                    offset++;
                }
            });

            var value = '';
            var isValid = true;
            var oldValue = placeholder;
            var oldValueUnmasked = '';
            var oldCaretPosition;
            var oldSelectionLength;
            var preventBackspace;
            var prevValue = input.value;

            function selectionLength() {
                return input.selectionEnd - input.selectionStart;
            }

            function isValidCaretPosition(pos) {
                return caretMap.indexOf(pos) > -1;
            }

            // Каретка меняется только в видимом поле с фокусом.
            function setCaretPosition(pos) {
                if (input.offsetWidth && input.offsetHeight && input === document.activeElement && document.hasFocus()) {
                    input.setSelectionRange(pos, pos);
                }
            }

            function validate(unmasked) {
                return unmasked.length ? unmasked.length >= minLength : true;
            }

            function unmaskValue(text) {
                var start = oldCaretPosition;
                var stop = start + selectionLength();
                var stripped = '';
                var from = 0;
                var unmasked = '';
                var rest = patterns.slice();
                text = text.toString();
                components.forEach(function (component) {
                    var position = component.position;
                    // Постоянная часть внутри выделения уже заменена вводом.
                    if (!(position >= start && position < stop)) {
                        if (position >= start) {
                            position += text.length - placeholder.length;
                        }
                        if (text.substring(position, position + component.value.length) === component.value) {
                            stripped += text.slice(from, position);
                            from = position + component.value.length;
                        }
                    }
                });
                (stripped + text.slice(from)).split('').forEach(function (chr) {
                    if (rest.length && rest[0].test(chr)) {
                        unmasked += chr;
                        rest.shift();
                    }
                });
                return unmasked;
            }

            function maskValue(unmasked) {
                var masked = '';
                var next = 0;
                for (var i = 0; i < placeholder.length; i++) {
                    masked += next < unmasked.length && i === caretMap[next] ? unmasked.charAt(next++) : placeholder.charAt(i);
                }
                return masked;
            }

            ngModel.$formatters.unshift(function (modelValue) {
                value = unmaskValue(modelValue || '');
                isValid = validate(value);
                ngModel.$setValidity('mask', isValid);
                return value && isValid ? maskValue(value) : undefined;
            });
            ngModel.$parsers.unshift(function (viewValue) {
                value = unmaskValue(viewValue || '');
                isValid = validate(value);
                // Маскированный текст поле получит позже, в обработчике события; модель видит его сразу.
                ngModel.$viewValue = value ? maskValue(value) : '';
                ngModel.$setValidity('mask', isValid);
                return isValid ? value : undefined;
            });
            ngModel.$isEmpty = function (viewValue) {
                return !unmaskValue(viewValue || '');
            };
            input.setAttribute('placeholder', placeholder);

            // Неполный номер стирается при уходе из поля. Изменённое значение сообщается событием change.
            input.addEventListener('blur', function () {
                oldCaretPosition = 0;
                oldSelectionLength = 0;
                if (!isValid || !value) {
                    input.value = '';
                    scope.$apply(function () {
                        if (!ngModel.$pristine) {
                            ngModel.$setViewValue('');
                        }
                    });
                }
                if (value !== prevValue) {
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                }
                prevValue = value;
            });

            // Выделение мышью, отпущенной за пределами поля, запоминается при уходе указателя.
            function onMouseout() {
                oldSelectionLength = selectionLength();
                input.removeEventListener('mouseout', onMouseout);
            }
            input.addEventListener('mousedown', function () {
                input.addEventListener('mouseout', onMouseout);
            });
            input.addEventListener('mouseup', function () {
                input.removeEventListener('mouseout', onMouseout);
            });

            input.addEventListener('keydown', function (event) {
                var caretPos = input.selectionStart - 1 || 0;
                // Backspace за постоянной частью маски: каретка встаёт за ближайшую позицию ввода.
                if (event.which === 8) {
                    while (caretPos >= 0) {
                        if (isValidCaretPosition(caretPos)) {
                            setCaretPosition(caretPos + 1);
                            break;
                        }
                        caretPos--;
                    }
                    preventBackspace = caretPos === -1;
                }
                if (event.which === 90 && event.ctrlKey) {
                    input.value = '';
                    event.preventDefault();
                }
            });

            function onEvent(event) {
                var which = event.which;
                var type = event.type;
                if (which === 16 || which === 91) {
                    return;
                }
                var val = input.value;
                var valMasked;
                var valAltered = false;
                var valUnmasked = unmaskValue(val);
                var caretPos = input.selectionStart || 0;
                var caretPosOld = oldCaretPosition || 0;
                var caretPosDelta = caretPos - caretPosOld;
                var caretPosMin = caretMap[0];
                var caretPosMax = caretMap[valUnmasked.length] || caretMap[0];
                var selectionLenOld = oldSelectionLength || 0;
                var isSelected = selectionLength() > 0;
                var wasSelected = selectionLenOld > 0;
                var isAddition = val.length > oldValue.length || (selectionLenOld && val.length > oldValue.length - selectionLenOld);
                var isDeletion = val.length < oldValue.length || (selectionLenOld && val.length === oldValue.length - selectionLenOld);
                var isSelection = which >= 37 && which <= 40 && event.shiftKey;
                // Событие input не сообщает клавишу: Backspace и Delete узнаются по сдвигу каретки.
                var isKeyBackspace = which === 8 || (type !== 'keyup' && isDeletion && caretPosDelta === -1);
                var isKeyDelete = which === 46 || (type !== 'keyup' && isDeletion && caretPosDelta === 0 && !wasSelected);
                var caretBumpBack = (which === 37 || isKeyBackspace || type === 'click') && caretPos > caretPosMin;

                oldSelectionLength = selectionLength();
                if (isSelection || (isSelected && (type === 'click' || type === 'keyup' || type === 'focus'))) {
                    return;
                }
                if (isKeyBackspace && preventBackspace) {
                    input.value = placeholder;
                    scope.$apply(function () {
                        ngModel.$setViewValue('');
                    });
                    setCaretPosition(caretPosOld);
                    return;
                }
                // Удаление постоянной части маски не меняет значение: удаляется соседний введённый знак.
                if (type === 'input' && isDeletion && !wasSelected && valUnmasked === oldValueUnmasked) {
                    while (isKeyBackspace && caretPos > caretPosMin && !isValidCaretPosition(caretPos)) {
                        caretPos--;
                    }
                    while (isKeyDelete && caretPos < caretPosMax && !isValidCaretPosition(caretPos)) {
                        caretPos++;
                    }
                    var charIndex = caretMap.indexOf(caretPos);
                    valUnmasked = valUnmasked.substring(0, charIndex) + valUnmasked.substring(charIndex + 1);
                    valAltered = valUnmasked !== oldValueUnmasked;
                }

                valMasked = maskValue(valUnmasked);
                oldValue = valMasked;
                oldValueUnmasked = valUnmasked;
                if (!valAltered && val.length > valMasked.length) {
                    valAltered = true;
                }
                input.value = valMasked;
                if (valAltered) {
                    scope.$apply(function () {
                        ngModel.$setViewValue(valMasked);
                    });
                }

                if (isAddition && caretPos <= caretPosMin) {
                    caretPos = caretPosMin + 1;
                }
                if (caretBumpBack) {
                    caretPos--;
                }
                caretPos = caretPos > caretPosMax ? caretPosMax : caretPos < caretPosMin ? caretPosMin : caretPos;
                while (!isValidCaretPosition(caretPos) && caretPos > caretPosMin && caretPos < caretPosMax) {
                    caretPos += caretBumpBack ? -1 : 1;
                }
                if ((caretBumpBack && caretPos < caretPosMax) || (isAddition && !isValidCaretPosition(caretPosOld))) {
                    caretPos++;
                }
                oldCaretPosition = caretPos;
                setCaretPosition(caretPos);
            }
            ['input', 'keyup', 'click', 'focus'].forEach(function (name) {
                input.addEventListener(name, onEvent);
            });
        }
    };
}]);
